const API_URL = process.env.REACT_APP_API_URL ?? "http://localhost:8000";

// Company logos are served through our API's caching proxy rather than the
// FMP image CDN directly — the CDN has recurring outages, and the proxy
// keeps serving its cached copy whenever FMP is down.
export const getSymbolImageUrl = (symbol: string): string =>
  `${API_URL}/api/public/symbol-image/${encodeURIComponent(symbol)}`;
